import React from 'react';
import { View, StyleSheet } from 'react-native';
import Skeleton from '../common/Skeleton';

const CardSkeleton: React.FC = () => {
  return (
    <View style={styles.container}>
      <Skeleton width="100%" height={120} borderRadius={12} />
      <View style={styles.content}>
        <Skeleton width="80%" height={18} borderRadius={4} />
        <Skeleton width="100%" height={14} borderRadius={4} style={{ marginTop: 8 }} />
        <Skeleton width="90%" height={14} borderRadius={4} style={{ marginTop: 6 }} />
        <View style={styles.footer}>
          <Skeleton width={80} height={14} borderRadius={4} />
          <Skeleton width={60} height={14} borderRadius={4} />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
    borderRadius: 12,
    overflow: 'hidden',
  },
  content: {
    padding: 12,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 12,
  },
});

export default CardSkeleton;
